import { render, staticRenderFns } from "./exview.vue?vue&type=template&id=2bdce74e&scoped=true"
import script from "./exview.vue?vue&type=script&lang=js"
export * from "./exview.vue?vue&type=script&lang=js"
import style0 from "./exview.vue?vue&type=style&index=0&id=2bdce74e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdce74e",
  null
  
)

export default component.exports